module.exports = __webpack_public_path__ + "assets/media/1.9614dbbf.wav";